import Icon from "../../Styled/Icon";
import Styles from "./mobile-menu-item.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MobileMenuItem = props => /*#__PURE__*/_jsx("div", {
  className: Styles.root,
  children: props.href ? /*#__PURE__*/_jsxs("a", {
    href: props.href,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: props.onClick,
    className: Styles.link,
    children: [props.caption, props.href !== "#" && /*#__PURE__*/_jsx(Icon, {
      glyph: Icon.GLYPHS.externalLink
    })]
  }) : /*#__PURE__*/_jsxs("button", {
    onClick: props.onClick,
    className: Styles.link,
    children: [props.icon && /*#__PURE__*/_jsx(Icon, {
      className: Styles.icon,
      glyph: props.icon
    }), props.caption]
  })
});
export default MobileMenuItem;